import type { AppLocale } from '@/urls'

export const en = {
    _prefix: '/en',
    _locale: 'en' as AppLocale,

    breadcrumbs: {
        mineArbeidsforhold: 'My employments',
        arbeidssted: 'Workplace',
        arbeidsforhold: 'Employment',
    },

    filter: {
        alle: 'All',
        aktive: 'Active',
        avsluttede: 'Ended',
        fremtidige: 'Future',
        ikkeValgt: 'Not selected',
        ingenTreff: 'No results',
        soekEtterNavn: 'Search by name',
        periode: 'Status',
        viserAntall: 'Showing %s of %s employments',
        sorterEtter: 'Sort by',
        sorterNavn: 'Name (A–Z)',
        sorterStartdato: 'Start date (newest first)',
        sorterSluttdato: 'End date (newest first)',
        sorterStillingsprosent: 'Percentage (highest first)',
        sorterYrke: 'Occupation (A–Z)',
    },

    term: {
        arbeidstaker: 'Employee',
        arbeidssted: 'Workplace',
        rapporteringsordning: 'Reporting scheme',
        arbeidsforholdstatus: 'Employment status',
        arbeidsforholdtype: 'Type of employment',
        foedselsnummer: 'Identity number',
        navn: 'Name',
        organisasjonsnummer: 'Organization number',
        organisasjonsnavn: 'Organization name',
        stillingsprosent: 'Employment percent',
        startdato: 'Start date',
        sluttdato: 'End date',
        yrke: 'Profession',
        arbeidsforhold: 'Employment',
    },

    detaljer: {
        arbeidstaker: 'Public ID',
        ansettelsesperiode: 'Employment period',
        hovedenhet: 'Main entity',
        underenhet: 'Sub-entity',
        opplysningspliktig: 'Reporting entity',
        organisasjonsnummer: 'Organization number %s',
        yrke: 'Profession',
        yrkeskode: 'Profession code',
        arbeidsforholdstype: 'Type of employment',
        arbeidsforholdId: 'Employment ID',
        arbeidstidsordning: 'Working scheme',
        ansettelsesform: 'Form of employment',
        avtaltStillingsprosent: 'Employment percent',
        sisteStillingsprosentEndring: 'Changed position percentage',
        sisteLonnsendring: 'Latest salary change',
        antallTimerPrUke: 'Hours/week',
        sistBekreftet: 'Last confirmed by reporting entity',
        sluttaarsak: 'Reason for termination',
        sluttaarsakMedVerdi: '(Reason for employment termination: %s)',
        fartsomraade: 'Shipping area',
        skipsregister: 'Ship register',
        fartoeystype: 'Vessel type',
        omArbeidsforholdet: 'Employment details',
        opprettet: 'Created',
        sistEndret: 'Last change',
        visEndringer: 'Show changes in employment',
        antallEndringer: '%s changes',
        enEndring: '1 change',
        visAlleEndringer: 'Show all %s changes',
        omRapporteringen: 'About the reporting',
        viserForDato: 'Showing employment as of %s',
        tilbakestillDato: 'Reset to current date',
        mangler: 'missing',
    },

    tabs: {
        arbeidiutlandet: 'Work abroad',
        historikk: 'History',
        permisjonpermittering: 'Leave/Layoff',
        timerfortimelonnet: 'Working hours for hourly-paid employees',
    },

    loading: {
        laster: 'Loading...',
        henterArbeidsforhold: 'Fetching employments...',
        hentArbeidsforholddetaljer: 'Fetching employment details...',
        hentPermisjoner: 'Fetching leaves',
        hentPermitteringer: 'Fetching layoffs',
        hentUtenlandsopphold: 'Fetching work abroad',
        hentTimerMedTimeloenn: 'Fetching working hours',
    },

    permisjon: {
        permisjon: 'Leave',
        type: 'Type of leave',
        periode: 'Period',
        prosent: 'Percentage',
        id: 'Leave ID',
        ingenTreff: 'No leaves found',
    },

    permittering: {
        permittering: 'Layoff',
        type: 'Type of layoff',
        periode: 'Period',
        prosent: 'Percentage',
        id: 'Layoff ID',
        ingenTreff: 'No layoffs found',
    },

    timerForTimeloennet: {
        timerForTimeloennet: 'Working hours',
        rapporteringsmaaned: 'Reporting month',
        rapporteringsperiode: 'Period',
        opptjeningsperiode: 'Worked in period',
        antallTimer: 'Number of hours',
        ingenTreff: 'No working hours found',
    },

    utenlandsopphold: {
        utenlandsopphold: 'Work abroad',
        rapporteringsmaaned: 'Reporting month',
        rapporteringsperiode: 'Period',
        land: 'Country',
        opptjeningsperiode: 'Accrual period',
        ingenTreff: 'No work abroad found',
    },

    historikk: {
        historikk: 'History',
    },

    varsel: {
        ERKONK: 'End date set by Nav. The employer has gone bankrupt. End date is the same date as the bankruptcy date reported to Konkursregisteret.',
        EROPPH: 'End date set by Nav. The employer has ceased to exist in Enhetsregisteret. The end date is set to the date the company ceased to exist.',
        ERVIRK: 'End date set by Nav. The company has been transferred to another legal entity. The end date is set to the date of transfer.',
        IBARBG: 'End date set by Nav. The employment has not been confirmed. End date is the last date of the calendar month in which the employment is confirmed.',
        IBKAOR: 'End date set by Nav. The employment has not been confirmed through a-ordningen. End date is set for 31.12.2014',
    },

    knapp: {
        loggInn: 'Log in',
        lagre: 'Save',
        fortsett: 'Continue',
        avbryt: 'Cancel',
        nullstillValg: 'Reset selection',
        lastNedPdf: 'Download PDF',
        lastNedExcel: 'Download Excel',
        skrivUtPdf: 'Print PDF',
        tilbake: 'Back to overview',
        endreDataelementer: 'Change data elements',
        velgDato: 'Select date',
        velgMaaned: 'Select month',
        soek: 'Search',
    },

    dataminimering: {
        velgDataelementer: 'Change data element selection',
        beskrivelse:
            'Only the selected data elements will be fetched and shown. Select only the data elements you need according to your legal basis for processing.',
        dataelementer: 'Data elements',
        grupper: {
            ansettelse: 'Employment',
            arbeidstidOgLoenn: 'Working hours and pay',
            historikkOgFravaer: 'History and absence',
            maritimt: 'Maritime',
        },
    },

    soek: {
        hvaVilDuSoekePaa: 'What do you want to search for?',
        identLabel: 'National ID, D-number or organization number',
        skrivInnFnr: 'Enter national ID/D-number',
        skrivInnOrgnr: 'Enter org.no./national ID/D-number',
        antallValgt: '%s selected',
        rapporteringsordning: {
            A_ORDNINGEN: 'A-ordningen',
            FOER_A_ORDNINGEN: 'Before a-ordningen',
        },
        arbeidsforholdstatus: {
            AKTIV: 'Active',
            FREMTIDIG: 'Future',
            AVSLUTTET: 'Ended',
        },
        arbeidsforholdtype: {
            ordinaertArbeidsforhold: 'Ordinary',
            maritimtArbeidsforhold: 'Maritime',
            frilanserOppdragstakerHonorarPersonerMm: 'Freelancer etc.',
            forenkletOppgjoersordning: 'Simplified',
        },
    },

    feil: {
        pdf: 'Could not create PDF',
        excel: 'Could not create Excel',
        fantIkke: {
            navn: '(Name missing)',
            arbeidsforholdsdetaljer: 'Employment details not found',
            permisjon: 'No leaves found',
            permittering: 'No layoffs found',
            timerMedTimeloenn: 'No working hours found',
            utenlandsopphold: 'No work abroad found',
        },
        validering: {
            soek: {
                arbeidssted: 'Must be 9 or 11 digits',
                arbeidstaker: 'Must be 11 digits',
                rapporteringsordning: 'You must select at least one reporting scheme',
                arbeidsforholdstatus: 'You must select at least one employment status',
                arbeidsforholdtype: 'You must select at least one type of employment',
            },
        },
    },

    tabell: {
        viserAvTotalt: 'Showing %start - %slutt of %total results',
        rader: 'Rows',
        visAlle: 'Show all (%s)',
        visFlere: 'Show more (%s)',
        visMindre: 'Show less',
        lukkAlleRader: 'Close all rows',
        utvidAlleRader: 'Expand all rows',
        velgAlleRader: 'Select all rows',
    },

    excel: {
        info: 'Info',
        omDokumentet: 'About the document',
        generertAv: 'Generated by the State register of employers and employees.',
        dato: 'Date',
        antallArbeidsforhold: 'Number of employments',
        beskrivelse:
            'This Excel file contains an overview of active and ended employments for the selected employee, as reported to the State register of employers and employees after 01.01.2015. \n If something is wrong with an employment, you as employer should correct this through the a-melding.',
        aktiveArbeidsforhold: 'Active employments',
        avsluttedeArbeidsforhold: 'Ended employments',
        varsel: 'Warning',
    },

    pdf: {
        footer1: 'The data is reported by employers to the State register of employers and employees',
        footer2: 'Norwegian Labour and Welfare Administration // Printed %s',
        detaljerOmArbeidsforholdet: 'Employment details',
        opplysningspliktig: 'Reporting entity',
        timerPerUkeIFullStilling: 'Hours per week in full position',
        foerstRapportert: 'First reported by reporting entity',
        sistRapportert: 'Last reported by reporting entity',
        arbeidsforholdSistEndret: 'Employment was last changed',
        permisjoner: 'Leaves',
        ingenRegistrertePermisjoner: 'No registered leaves.',
        permitteringer: 'Layoffs',
        ingenRegistrertePermitteringer: 'No registered layoffs.',
        ingenRegistrertArbeidIUtlandet: 'No registered work abroad.',
        rapporteringsmaaned: 'Reporting month',
        ingenRegistrerteTimerMedTimeloenn: 'No registered working hours.',
        ingenRegistrerteEndringer: 'No registered changes.',
        endretTil: 'Changed to',
        av: 'of',
        periode: 'Period',
        stillingsprosentendring: 'Position percentage change',
        antallTimerPerUke: 'Hours per week',
        id: 'ID',
        utskrift: 'Print',
        side: 'Page',
        timerPerUkeEnhet: 'hours per week',
        lonnsendring: 'Salary change',
        typeArbeidsforhold: 'Type of employment',
    },

    info: {
        hvisfeil1: 'The overview displays employments reported after 01.01.2015.',
        hvisfeil2: 'If something is wrong with the registered information, contact your employer.',
        ingenArbeidsforhold: 'You have no registered employments.',
        opplysningIkkeValgt: 'Information not selected',
        ingenData: 'No data',
    },

    landing: {
        loggInn: 'Log in',
        arbeidstaker: {
            heading: 'Access to the State register for employees',
            body: 'Log in to see an overview of all employments your employers have reported on you through the a-melding.',
            linkArbeidsgiverTitle: 'See services for employers',
            linkArbeidsgiverDescription: 'Go to the logged-in pages',
        },
        arbeidsgiver: {
            heading: 'Access to the State register for employers',
            body: 'Log in to see an overview of all employments you as an employer have reported through the a-melding.',
            linkTilgangTitle: 'How do I get access?',
            linkTilgangDescription: 'Learn about roles and access rights in Altinn',
            linkPrivatTitle: 'See services for private individuals',
            linkPrivatDescription: 'Go to the logged-in pages',
        },
        samarbeidspartner: {
            heading: 'Access to the State register for partners',
            introBefore: 'Everyone who has ',
            introLink: 'applied',
            introAfter: ' for and been granted access may use the service.',
            introLine2: 'Here you can look up either an employer (organisation number) or an employee (national identity number/D-number).',
            subheading: 'More about the service:',
            brukerveiledningBefore: 'Here you will find the ',
            brukerveiledningLink: 'user guide for the service',
            brukerveiledningAfter: '.',
            gratis: 'The service is free to use.',
            sperretAdresse:
                'Information about persons with restricted addresses under section 10-4 of the Population Register Act is not disclosed.',
            utloggetInaktivitet: 'You will be logged out after ????? hours of inactivity.',
            dataminimering:
                'Your choices for data minimisation and filtering are stored during the session, but must be made again at next login.',
            driftsvarslerBefore: 'You can follow ',
            driftsvarslerLink: 'news and operational notifications',
            driftsvarslerAfter: ' related to the service.',
            infoBoxTitle: 'Access is granted in Altinn',
            infoBoxLink: 'Read more here',
        },
    },

    ingenTilgang: {
        arbeidsgiver: {
            heading: 'Access to the State register for employers',
            body: 'Here you will find an overview of all employments reported through the a-melding.',
            ikkeTilgangTitle: 'You do not have access to the service',
            aarsakerIntro: 'There may be several reasons why you do not have access:',
            aarsak1:
                'You have not been delegated access to the service in Altinn by the main administrator or access manager of the organisation.',
            aarsak2: 'You do not hold a role in the Register of Legal Entities that grants access to this service.',
            hvordanTilgangTitle: 'How do I get access?',
            hvordanTilgangBodyBefore:
                'To access the service for employments reported through the a-melding, you need the single service “Innsyn i Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret) for arbeidsgivere” in ',
            hvordanTilgangBodyLink: 'Altinn',
            hvordanTilgangBodyAfter: '.',
            hvordanTilgangRollerIntro:
                'Access is also granted automatically to persons with the following roles in the Register of Legal Entities:',
            hvordanTilgangRoller: [
                'general manager/chief executive officer',
                'chair of the board',
                'owner of a sole proprietorship',
                'partner in a general partnership (ANS and DA)',
                'managing shipowner',
                'trustee in bankruptcy (does not include the bankrupt business) and other estates',
                'general partner (personal identification number only)',
                'Norwegian representative of a foreign entity',
            ],
            linkPrivatTitle: 'See services for private individuals',
            linkPrivatDescription: 'Go to the logged-in pages',
            linkTilgangTitle: 'How do I get access?',
            linkTilgangDescription: 'Learn about roles and access rights in Altinn',
        },
        samarbeidspartner: {
            heading: 'Access to the State register for partners',
            body: 'Here you will find an overview of employments reported through the a-melding.',
            ikkeTilgangTitle: 'You do not have access to the service',
            aarsakerIntro: 'There may be several reasons why you do not have access:',
            aarsak1: 'You have not been delegated access in Altinn by an administrator.',
            aarsak2: 'Your roles and access rights in Altinn do not give access to this service.',
            linkTilgangTitle: 'How do I get access?',
            linkTilgangDescription: 'Learn about roles and access rights in Altinn',
        },
    },

    bruksvilkaar: {
        heading: 'Terms of use',
        velkommen: 'Welcome to the web access solution for the State register of employers and employees (Aa-registeret).',
        forBenytte: 'Before using the service, you must be aware of the following:',
        taushetspliktLine1:
            'All information in the Aa-register is subject to a statutory duty of confidentiality, cf. section 16 of the regulations on the Aa-register. You are required to familiarise yourself with what this entails before using the service. By ticking the box confirming that you have read and understood the terms of use, you confirm that you are aware of the duty of confidentiality and that you commit to complying with it.',
        taushetspliktLine2Before:
            'You will find more information about the duty of confidentiality and what it entails in the terms of use that your organisation has approved and committed to comply with in chapter 10 ',
        taushetspliktLine2Link: 'here',
        taushetspliktLine2After: '.',
        taushetspliktLine3:
            'Breach of the duty of confidentiality may be punished by fines or imprisonment for up to 1 year, see section 209 of the Penal Code.',
        dataminimeringLine1:
            'You are obliged not to look up, or retrieve, more data elements from the Aa-register than is necessary based on the purpose for which access has been granted, including what is required for your professional duties.',
        dataminimeringLine2:
            'When applying for access to the Aa-register, your employer has stated which data elements are necessary to look up based on the purpose of the access for your organisation. If you find that there is a need to use more data elements than these, your employer must apply to have the access expanded accordingly. We must have approved this application before any lawful lookup is performed. If you do not know which data elements your employer has stated as necessary, contact your employer before using the service.',
        uforenelig: 'The information may not be used for purposes that are incompatible with the original purpose (unauthorised lookup).',
        logging:
            'All lookups are logged at both system and personal level, and can be traced afterwards. The registered person is generally entitled to access such logs upon request. NAV is entitled to use these logs as a basis if unauthorised lookups are suspected.',
        avslutningBefore:
            'We recommend that you familiarise yourself with the other terms of use that your organisation has approved and committed to comply with in order to use the service. Here you will find the ',
        avslutningLink: 'general terms of use',
        avslutningAfter: ' for use of the Aa-register.',
        checkboxLabel: 'I have read and understood the terms of use',
        godtaButton: 'Accept terms',
    },

    arbeidsgiverHovedenhet: {
        underenheterInfo: 'The overview shows sub-entities where the main entity has or has had reported employments.',
        undetenheterInfo2:
            'There may be additional workplaces (sub-entities) under this main entity that are not shown because no employees have ever been reported there.',
        clearUnderenhetButtonLabel: 'Clear search field',
        sokPlaceholder: 'Search sub-entity...',
        sokLabel: 'Search sub-entity',
        ingenUnderenheter: 'The entity has no sub-entities with reported employments',
        fantIkkeUnderenhet: 'No sub-entities matching your search were found',
        lesMer: 'About this list',
        merkelapp: 'Main entity',
        sorterArbeidsforhold: 'Number of employments (highest first)',
        viserAntall: 'Showing %s of %s sub-entities',
        visFlere: 'Show more sub-entities',
    },
    underenhetTableRow: {
        copyIdent: 'Copy organization number for ',
        aktiveArbForhold: 'active employments',
        inaktiveArbForhold: 'inactive employments',
    },

    kopier: {
        fnrMedNavn: 'Copy national identity number for %s',
        orgnrMedNavn: 'Copy organization number for %s',
        fnr: 'Copy national identity number',
        orgnr: 'Copy organization number',
    },

    hjelpetekst: {
        om: 'About %s',
        arbeidssted: 'The sub-entity the employee works at. For a private individual acting as employer, the workplace is that person.',
        opplysningspliktig:
            'The party obliged to report information about the employment, in practice through the a-melding. For an organisation this is the main entity; for a private individual acting as employer, that person.',
        startdato: 'The date the employment starts according to the employment contract. It is not necessarily the first day at work.',
        sluttdato:
            'The date the employment ends. This is not always the last day the employee is at work, because the employment is not formally over until any rota period has ended or any time off in lieu has been taken.',
        sluttaarsak: 'The reason the employment was terminated.',
        yrke: 'The combination of job title and occupation code. The occupation code is a seven-digit code in the occupation catalogue maintained by Statistics Norway, and is determined by the work the employee actually performs – not by their level of education or type of position.',
        avtaltStillingsprosent: "The percentage the employee's agreed working hours make up of full time for an equivalent position.",
        sisteStillingsprosentEndring: 'The date the employment percentage was most recently changed.',
        antallTimerPrUke:
            'The number of hours per week that makes up a 100 % position. Used among other things to calculate the employment percentage for part-time employees.',
        ansettelsesform: 'Whether the employee is permanently or temporarily employed.',
        arbeidstidsordning: 'The agreement on when during the day the work is to be performed, and any variations over a period.',
        sisteLonnsendring: 'The date the employee most recently had a change in salary.',
        fartsomraade: 'The defined area in which the maritime employment takes place, either domestic or international waters.',
        skipsregister:
            'The register the maritime vessel is registered in: NOR (Norwegian Ordinary Ship Register), NIS (Norwegian International Ship Register) or UTLA (foreign-registered vessel).',
        fartoeystype:
            'The type of seagoing vessel the maritime employment takes place on, for example a tourist ship or a drilling platform.',
        opprettet: 'The time the employment was created in Aa-registeret.',
        sistEndret: 'The time Nav most recently received and applied a change to one or more data fields in the employment.',
        sistBekreftet:
            'The time the most recently received a-melding for the employment was processed. The reporting entity confirms the employment by submitting an a-melding.',
        rapporteringsordning:
            'Indicates whether the employment was reported through a-ordningen, introduced on 01.01.2015, or through the previous reporting scheme.',
        arbeidsforholdId:
            'The identifier that distinguishes individual employments from each other when the employee or freelancer has several employments in the same sub-entity.',
        permisjon: {
            periode: 'The period the employee is on leave, given as the first and last day of leave.',
            type: 'A short, predefined text describing the basis for the leave.',
            prosent: "The percentage the leave makes up of the employee's agreed employment percentage.",
            id: 'An identifier unique to the leave within the employment. The employer must use a new identifier for a later leave, or for leaves that overlap in time.',
        },
        permittering: {
            periode:
                'The period the employer has laid off the employee. It starts when the layoff takes effect, usually the first day of pay liability.',
            type: 'A short, predefined text describing the basis for the layoff.',
            prosent: "The percentage the layoff makes up of the employee's agreed employment percentage.",
            id: 'An identifier unique to the layoff within the employment. The employer must use a new identifier if the employee is laid off again later.',
        },
        timerForTimeloennet: {
            rapporteringsmaaned: 'The month the information was reported for. It is not necessarily the same as the accrual period.',
            opptjeningsperiode: 'The period the hours were worked in. Only given when the employer has reported it.',
            antallTimer:
                'The number of working hours forming the basis for paying an hourly-paid employee. Overtime hours are not included in Aa-registeret.',
        },
        utenlandsopphold: {
            rapporteringsmaaned: 'The month the information was reported for. It is not necessarily the same as the accrual period.',
            opptjeningsperiode: 'The period the income was earned in. Only given when the employer has reported it.',
            land: 'The country the employee earned income in.',
        },
    },

    footer: {
        informasjon: 'About the service',
        driftsvarsler: 'News and service messages',
        driftsvarslerBeskrivelse: 'Changes to the service and notices of planned or unexpected downtime.',
        brukerstoette: 'User support',
        brukerstoetteHeading: 'Professional, functional or technical questions about the Aa-register',
        faqBefore: 'Before you send professional, functional or technical questions to user support, please check the ',
        faqLink: 'frequently asked questions',
        faqAfter: '.',
        dokumentasjonBefore: 'See also the ',
        dokumentasjonLink: 'professional and technical description of the services',
        dokumentasjonAfter: ' (Github).',
        naarKontakte: 'If you do not find the answer to your question, you can contact user support when you:',
        kontaktPunkt1: 'Have professional, functional or technical questions about the Aa-register and this service',
        kontaktPunkt2: 'Have information about incorrect or missing data in the register',
        kontaktPunkt3: 'Want to report errors or security breaches in the service',
        kontaktPunkt4: 'Want to suggest changes',
        tilgangMerknad: 'Please note: Questions about applying for access to the Aa-register do not apply to employers and employees.',
        merInformasjonLink: 'Here you will find more information about the State register of employers and employees',
        arbeidstaker: {
            regionLabel: 'Help and information',
            informasjonBeskrivelse: 'What the overview shows, who owns the Aa-register and what Nav uses the information for.',
            brukerstoetteBeskrivelse: 'Questions and answers, and what to do if the information about your employments is incorrect.',
            informasjonAvsnitt1:
                'The overview shows all employments reported after 01.01.2015, as reported by the employer. If something is wrong with an employment, the employer can correct it through the a-melding.',
            informasjonAvsnitt2:
                'Nav needs information about your employments in order to assess your need for follow-up and services from Nav, and to calculate how much you can receive in, for example, sickness benefit, unemployment benefit and parental benefit. Other public agencies also have access to information from the State register of employers and employees.',
            informasjonAvsnitt3:
                'The Norwegian Labour and Welfare Administration owns and manages the State register of employers and employees (Aa-registeret).',
            feilHeading: 'Is the information about your employments incorrect?',
            feilAvsnitt1:
                'If the information about your employments in the State register of employers and employees is incorrect, contact your employer, who can correct it through the a-melding.',
            feilAvsnitt2: 'If your employer cannot help you, you can contact Nav user support for the Aa-register.',
        },
        arbeidsgiver: {
            regionLabel: 'Help and information',
            informasjonBeskrivelse:
                'What the overview shows, how to correct errors through the a-melding and what Nav uses the information for.',
            brukerstoetteBeskrivelse: 'Do you have questions about the Aa-register, the a-melding or logging in to the service?',
            informasjonAvsnitt1:
                'The overview shows all employments reported after 01.01.2015 for the selected organisation. If you find errors in the overview, you as the employer must correct them through the a-melding.',
            aMeldingBefore: 'See ',
            aMeldingLink: 'the Norwegian Tax Administration’s guide to the a-melding',
            aMeldingAfter: '.',
            informasjonAvsnitt2:
                'Nav needs information about the employments in order to assess the need for follow-up and services from Nav, and to calculate how much your employees can receive in, for example, sickness benefit, unemployment benefit and parental benefit. Other public agencies also have access to information from the State register of employers and employees.',
            informasjonAvsnitt3:
                'The Norwegian Labour and Welfare Administration owns and manages the State register of employers and employees (Aa-registeret).',
            brukerstoette: {
                altinnHeading: 'Do you have questions about the Altinn rights for the service or logging in via Altinn?',
                altinnBefore:
                    'If you have questions about delegating the Altinn right “Innsyn i Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret) for arbeidsgivere” or about logging in, you can ',
                altinnLink: 'get help from Altinn',
                altinnAfter: ' (',
                altinnKildeLink: 'Altinn.no',
                altinnKildeAfter: ').',
                aMeldingHeading: 'How do you report employments to the Aa-register through the a-melding?',
                aMeldingBefore:
                    'If you have questions about how to report employments or make corrections, you will find more information in ',
                aMeldingVeiledningLink: 'the guide to the a-melding',
                aMeldingMellom: ', or you can ',
                aMeldingKontaktLink: 'contact the a-ordningen',
                aMeldingAfter: ' (',
                aMeldingKildeLink: 'Skatteetaten.no',
                aMeldingKildeAfter: ').',
                andreHeading: 'Other questions about the Aa-register',
                andreBefore:
                    'You will find more information about what the Aa-register is, the duty to report to the register, what information the register contains, and who can receive information from the register on this page ',
                andreLink: 'about the Aa-register on nav.no',
                andreMellom: ', or you can ',
                andreKontaktLink: 'contact Nav registerforvaltning',
                andreAfter: '.',
            },
        },
        samarbeidspartner: {
            regionLabel: 'Help and contact',
            kontaktKnapp: 'Contact the Aa-register',
            brukerveiledning: 'User guide (pdf)',
            brukerveiledningBeskrivelse: 'Step by step through web lookups in the Aa-register.',
            tips: 'Report missing or incorrect information',
            tipsBeskrivelse: 'What to report, what a good report contains and how to submit it.',
            brukerstoetteLenke: 'Professional, functional or technical support',
            brukerstoetteBeskrivelse: 'Questions and answers, technical description of the services and when to contact user support.',
            kontaktPunkt1: 'Have information about incorrect or missing data in the register',
            kontaktPunkt2: 'Have professional, functional or technical questions about the Aa-register and the distribution solutions',
            kontaktPunkt3: 'Want to suggest changes',
            kontaktPunkt4: 'Want to report errors or security breaches in the service',
            kontaktPunkt5: 'Have questions about applying for access to the Aa-register',
            klikkBefore: 'Click ',
            klikkLink: '“Contact the Aa-register”',
            klikkAfter: ' and state the category you think fits best. It is not critical if you choose the wrong category.',
            beskrivHenvendelse:
                'Describe your enquiry as clearly as possible. You can also upload attachments if they are important for explaining the enquiry.',
            tipsHeading: 'Report incorrect or missing information in the register',
            tipsIntro:
                'If you see incorrect or missing information in the register, we would like you to report it through Nav’s user support solution.',
            tipsEksemplerIntro: 'Examples of what you can report:',
            tipsEksempel1: 'Incorrect or missing start and/or end date',
            tipsEksempel2: 'An employment has not been reported, but should have been',
            tipsEksempel3: 'Suspicion of fictitious employments',
            tipsEksempel4: 'Missing or incorrect reporting of leave or temporary lay-off',
            tipsEksempel5: 'Incorrect percentage of full-time position',
            tipsEksempel6: 'Missing reporting of income, although the employment has been reported',
            tipsInnholdIntro: 'A good report about possible incorrect or missing information in the Aa-register must contain:',
            tipsInnhold1: 'The name and national identity number of the person concerned',
            tipsInnhold2: 'Who the employer is (organisation number)',
            tipsInnhold3: 'The date the matter was discovered',
            tipsInnhold4: 'The background for the report',
            tipsInnhold5: 'All documentation and information supporting the report that you are permitted to share',
            tipsInnhold6: 'Whether an employment contract or timesheets exist',
            tipsInnhold7: 'Other information indicating that the person works there',
            tipsInnhold8: 'An assessment of how likely it is that a genuine employment exists',
            tipsInnhold9: 'Whether you have given any information to the employer, and what',
            tipsKlikk:
                'Click “Contact the Aa-register” and select the category “Report incorrect or missing information in the register” in the subject field, then provide the information and any attachments.',
            tipsPostBefore: 'If you cannot use the user support solution, you can send your report by post: ',
            tipsPostLink: 'Send by post',
            tipsPostAfter:
                '. This does not require logging in. In the next step, select “Several people at once or labour market enterprises, course organisers and other organisations” for who the submission concerns, and Nav registerforvaltning as the receiving unit.',
        },
    },
}
